import {Separation} from '@viptech/react-components'
import SmallCheckIconStepper from 'src/components/stepper/SmallCheckIconStepper'
import usePersonalizedThemeByCompany from 'src/hooks/usePersonalizedThemeByCompany'
import {
  ContainerColumn,
  ContainerRow,
  StepperBorder,
  StepperChildrenContainer,
  StepperContainer,
  StepperDefault,
  StepperResume,
  StepperStageTitle,
  StepperTitle,
  StepperTitlesContainer,
} from './StepperBase'
import {StepperProps} from './StepperProps'

export default function Stepper(props: StepperProps) {
  const {steps} = props
  const activeChildren = steps.find((it) => it.stepperStatus === 'active')
  const {styledTheme} = usePersonalizedThemeByCompany()
  return (
    <>
      <div style={{display: 'flex', justifyContent: 'center'}}>
        <ContainerRow>
          {steps.map((it, index) => {
            return (
              <ContainerColumn>
                <StepperContainer>
                  <StepperBorder status={it.stepperStatus}>
                    <StepperDefault status={it.stepperStatus}>{it.stepperStatus === 'concluded' && <SmallCheckIconStepper />}</StepperDefault>
                  </StepperBorder>
                  {index !== steps.length - 1 && (
                    <Separation
                      padding='1em'
                      width='100%'
                      color={
                        it.stepperStatus === 'concluded'
                          ? styledTheme.stepper.concludedColor
                          : it.stepperStatus === 'active'
                            ? styledTheme.stepper.activedColor
                            : '#D6E2F3'
                      }
                    />
                  )}
                </StepperContainer>

                <StepperTitlesContainer>
                  <StepperStageTitle>{it.stepperStageTitle}</StepperStageTitle>
                  <StepperTitle status={it.stepperStatus}>{it.stepperTitle}</StepperTitle>
                  <StepperResume status={it.stepperStatus}>
                    {it.stepperStatus === 'concluded'
                      ? it.resume
                      : it.stepperStatus === 'active'
                        ? 'Em progresso'
                        : it.stepperStatus === 'pending'
                          ? 'Pendente'
                          : ''}
                  </StepperResume>
                </StepperTitlesContainer>
              </ContainerColumn>
            )
          })}
        </ContainerRow>
      </div>
      <StepperChildrenContainer>{activeChildren?.children}</StepperChildrenContainer>
    </>
  )
}
